import { api } from '../../lib/apiClient';
import type { Session, User } from '../../types/api';

export const authApi = {
  login(email: string, password: string): Promise<Session> {
    return api.post<Session>('/auth/login', { email, password }, { skipRefresh: true });
  },

  logout(): Promise<void> {
    return api.post<void>('/auth/logout', undefined, { skipRefresh: true });
  },

  me(): Promise<User> {
    return api.get<User>('/auth/me');
  },

  changePassword(currentPassword: string, newPassword: string): Promise<void> {
    return api.post<void>('/auth/change-password', {
      current_password: currentPassword,
      new_password: newPassword,
    });
  },
};
